import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import saplingPoolReportIcon from './../../../assets/img/mm/chart-column-solid-full.svg';
import download from 'downloadjs';
class SamplingPoolSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }

    getSamplingPoolReport = (format) => {
        const districtID = this.state.userInfo.districtId;
        const verificationYear = this.props.selectedSchoolYear;
        const schoolId = this.props.selectedSchoolId;
        const reportFormat = format.toLowerCase();
        this.setState({ loading: true });
        const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';       
         get(`/verification/reports/samplingPool/export/${districtID}/${verificationYear}?${schoolParam}format=${reportFormat}&access_token=`
        ).then((response) => {
            if (!response.ok) {
                return response.json().then((errorResponse) => {
                    throw new Error(
                        errorResponse.statusMessage ||
                        errorResponse.errorMessage ||
                        "No data found."
                    );
                });
            }
            return response.blob();
        })
        .then((blob) => {
            if (reportFormat === "pdf") {
                // PDF - open in browser
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 1000);
            } else if (reportFormat === "xlsx") {
                // Excel - download file
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = "SamplingPoolReport.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            this.setState({ loading: false });
        })
        .catch((error) => {
            console.log("getSamplingPoolReport error:", error);
            _addNotificationError(error.message || "No data found.",this.props);
            this.setState({ loading: false });
        });
    };
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget" style={{ minHeight: '100px' }}>
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={saplingPoolReportIcon} style={{ width: '40px', height: '40px' }} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Sampling Pool Selection Report</b></span>
                                    <p>Error-prone flags,method,roster</p>
                                </div>
                            </div>
                             <div className='reportCard-widget-meeting-action' style={{
                                                                                        marginLeft: 'auto',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center' }}>
                                <div className="form-group" >
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px 5px 0px 0px'}} onClick={() => {
                                        this.getSamplingPoolReport('PDF')
                                    }}>
                                        <i className="fa fa-file-pdf-o" /> Pdf
                                    </button>
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={() => {
                                        this.getSamplingPoolReport('XLSX')
                                    }}>
                                        <i className="fa fa-file-excel-o" /> Excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default SamplingPoolSelection;


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/samplingPoolSelection.js